import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils.ts";
import IconJoinChallenge from "/public/join_challenge.svg?react"
interface JoinChallengePromptProps {
  className?: string;
}

const JoinChallengePrompt = ({ className }: JoinChallengePromptProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "flex flex-col items-center h-[268px] bg-white/08  rounded-14 justify-center ", className)}>
      <IconJoinChallenge className="mb-2"/>
      <h1 className="text-center mb-2 font-semibold leading-130 text-xl  text-white">
      {t("join_the_challenge")} 🙃
      </h1>
      <p className="text-center text-sm leading-130 text-gray-1 font-normal">{t("join_the_challenge_desc")}</p>
    </div>
  );
};

export default JoinChallengePrompt;